import React, { Fragment, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { bool, shape } from "prop-types";
import { push } from "connected-react-router";
import { useLocation, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { isEmpty } from "lodash";
import * as i18n from "util/i18n";
import { transactionStatus } from "pages/transactions/constants";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import MainContainer from "pages/_components/MainContainer";
import GridTable from "pages/_components/GridTable/GridTable";
import Notification from "pages/_components/Notification";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Button from "pages/_components/Button";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";
// eslint-disable-next-line import/no-named-as-default
import ResponsiveHeader from "pages/_components/header";

const LinkServiceTransactionPage = ({ isDesktop, transaction, linkServiceStatus }) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const dispatch = useDispatch();
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const [showToken, setShowToken] = useState(false);
    const [buttonLabel, setButtonLabel] = useState(
        isDesktop ? "eunsecured.loan.seeMore.ticket.button" : "unsecured.loan.seeLess.ticket.button",
    );
    const isBackoffice = pathname.includes("backoffice");
    const isLoading = !transaction || !transaction?.data?.params;

    const { user } = useSelector((_state) => _state.session);

    const showSignButton =
        isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId)) &&
        transaction.idTransactionStatus === transactionStatus.PENDING;

    const transactionData = {
        categoryName: transaction?.data?.params?.categoryName || "",
        entityName: transaction?.data?.params?.entityName || "",
        alias: transaction?.data?.params?.alias || "",
        paymentCode: transaction?.data?.params?.paymentCode || "",
        entityId: transaction?.data?.params?.entityId,
        categoryId: transaction?.data?.params?.categoryId,
    };

    const tagType =
        // eslint-disable-next-line no-nested-ternary
        transaction.idTransactionStatus === transactionStatus.FINISHED
            ? "tag-success"
            : transaction.idTransactionStatus === transactionStatus.FAILED ||
                transaction.idTransactionStatus === transactionStatus.CANCELLED
                ? "tag-error"
                : "tag-warning";

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id]);

    useEffect(() => {
        if (!transaction?.data?.params && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [transaction]);

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "activities.link.service",
        id,
        "link.service",
    );

    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    const requestBody = {
        idTransaction: id,
        serviceData: {
            entityId: transaction?.data?.params?.entityId,
            alias: transaction?.data?.params?.alias,
        },
    };

    // eslint-disable-next-line no-confusing-arrow
    const sign = () =>
        !showToken ? (
            <Col xs={12} md={4}>
                <CustomButton
                    func={() => setShowToken(true)}
                    text="forms.signTransaction.link"
                    textType="I18N"
                    className="btn btn-primary"
                />
            </Col>
        ) : (
            <GeneralCredentialForm
                transactionData={requestBody}
                type="otp"
                action={afipPaymentLinkActions.linkService}
                idActivity="link.service"
                hideIndications
            />
        );

    const transactionStatusID = () => {
        let statusId;
        switch (transaction?.idTransactionStatus) {
            case transactionStatus.PENDING:
                statusId = transactionStatus.PENDING;
                break;
            case transactionStatus.FINISHED:
                statusId = "APPROVED";
                break;
            default:
                statusId = "REJECTED";
                break;
        }
        return statusId;
    };

    return (
        <Fragment>
            <Notification scopeToShow="linkedservice.trasaction" />
            {!isBackoffice && <ResponsiveHeader ticket metaTitle="linkedservice.ticket.title" />}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title="linkedservice.ticket.title"
                                subTitle={`cashout.transaction.status.${transactionStatusID()}`}
                                isDesktop
                            />
                            <div className="ticket cashout">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <div className="ticket__body ticket__full-width">
                                        <GridTable>
                                            <GridTable.Container columnsTemplate="1fr 1fr">
                                                {isDesktop && (<>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                </>
                                                )}
                                                <GridTable.Data className="origin-account">
                                                    <TransactionInfo
                                                        fieldString={i18n.get("linkedservice.ticket.body.rubro")}
                                                        value={transactionData.categoryName}
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data className="phone-number">
                                                    <TransactionInfo
                                                        fieldString={i18n.get("linkedservice.ticket.body.empresa")}
                                                        value={transactionData.entityName}
                                                    />
                                                </GridTable.Data>
                                                {isDesktop && (<>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                </>
                                                )}
                                                <GridTable.Data className="name">
                                                    <TransactionInfo
                                                        fieldString={i18n.get("linkedservice.ticket.body.codigopago")}
                                                        value={transactionData.paymentCode}
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data className="name">
                                                    <TransactionInfo
                                                        fieldString={i18n.get("linkedservice.ticket.body.alias")}
                                                        value={transactionData.alias}
                                                    />
                                                </GridTable.Data>
                                                {isDesktop && (<>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                    <GridTable.Data>
                                                        &nbsp;
                                                    </GridTable.Data>
                                                </>
                                                )}
                                                <GridTable.Data className="document-number">
                                                    <TransactionInfo
                                                        fieldString="DNI"
                                                        value={transactionData.documentNumber}
                                                    />
                                                </GridTable.Data>
                                                <GridTable.Data className="phone-number">
                                                    <TransactionInfo
                                                        fieldString="Referencia"
                                                        value={transactionData.reference}
                                                    />
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable>
                                    </div>
                                    <div className="ticket__body ticket__full-width">
                                        {transaction.idTransactionStatus === transactionStatus.PENDING ? (
                                            <TransactionSign
                                                isDesktop={isDesktop}
                                                noDate
                                                creationTime
                                                isSmall
                                                showMoreData={showMoreData}
                                                hasVoucherInPending
                                                hasVaucher
                                            />
                                        ) : (
                                            <TransactionSign
                                                isDesktop={isDesktop}
                                                hasVaucher
                                                showMoreData={showMoreData}
                                                showSignatures
                                            />
                                        )}
                                    </div>

                                    <Row className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                </div>

                {!isBackoffice && (
                    <Row className="form-actions">
                        <Row>
                            {transaction?.data?.idTransactionStatus !== "FAILED" ? (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        {(!showToken || linkServiceStatus != null) && (
                                            <CustomButton
                                                func={() => dispatch(push("/desktop"))}
                                                text="forms.transaction.ticket.actions.backToHome"
                                                textType="I18N"
                                                className="btn btn-outline"
                                            />
                                        )}
                                    </Col>
                                    {!showSignButton ? (
                                        <Col xs={12} md={4}>

                                            <Button
                                                className="btn btn-primary"
                                                image="images/figma/icon/download.svg"
                                                label="global.download"
                                                onClick={handleDownload}
                                            />

                                        </Col>
                                    ) : (
                                        sign()
                                    )}
                                    {!showSignButton && !isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                </>
                            ) : (
                                <Col xs={12} md={4} mdOffset={4}>
                                    <CustomButton
                                        func={() => { }}
                                        text="forms.transaction.ticket.actions.backToHome"
                                        textType="I18N"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                        {transaction.idTransactionStatus === transactionStatus.FINISHED && <Row>
                            <Col xs={12} md={4} mdOffset={4}>
                                <Button
                                    className="btn-link"
                                    label="adheredServices.link.menu.pay"
                                    onClick={() => {
                                        dispatch(afipPaymentLinkActions.setAddedServicePaymentData(transactionData));
                                        dispatch(push("/newServicePayment"));
                                    }}
                                />
                            </Col>
                        </Row>}
                    </Row>
                )}
            </MainContainer>
        </Fragment>
    );
};

LinkServiceTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
    transaction: shape({}).isRequired,
};

const mapStateToProps = (state) => ({
    fetching: accountsSelectors.getFetching(state),
    transaction: formSelectors.getTransaction(state),
    linkServiceStatus: afipPaymentLinkSelectors.getLinkServiceStatus(state),
});

export default connect(mapStateToProps)(LinkServiceTransactionPage);
